import { ObjectDetailsComponent } from "./components/object-details";

export { ObjectDetailsComponent };
